import { Banner, Page } from '@/components';
import { Box, Heading } from '@blockanalitica/ui';
import TokensBaseTable from './tokens_base_table';
import TokensArbitrumTable from './TokensArbitrumTable';
import TokensOptimismTable from './TokensOptimismTable';
import TokensTable from './TokensTable';
import TokensUnichainTable from './TokensUnichainTable';
export default function TokensPage() {
  return (
    <Page title="Tokens">
      <Banner>
        <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
          <Heading size="2">About the Sky Protocol Tokens</Heading>
          <br />
          Explore the official Sky Ecosystem tokens across all blockchains,
          including live metrics such as market cap, supply and unique holders.
        </Box>
      </Banner>
      <Heading size="1">Ethereum</Heading>
      <TokensTable />
      <Heading size="1">Base</Heading>
      <TokensBaseTable />
      <Heading size="1">Arbitrum</Heading>
      <TokensArbitrumTable />
      <Heading size="1">Optimism</Heading>
      <TokensOptimismTable />
      <Heading size="1">Unichain</Heading>
      <TokensUnichainTable />
    </Page>
  );
}
